import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { client } from '@Utils'
import { toast } from '@CommonComponents/toast'

const LaunchRecreationInput = props => {
  const [launchUrl, setLaunchUrl] = useState(
    props.log.params.launch_url ? props.log.params.launch_url : ''
  )

  const launch = async () => {
    let data = {
      url: launchUrl,
      logId: props.log.id,
    }

    let resp = await client.post(
      '/account/support_dashboard.recreate_lti_launch',
      data
    )

    if (resp.status === 200) {
      let form = document.createElement('form')
      form.className = 'd-none'
      form.method = 'POST'
      form.action = launchUrl

      for (let key in resp.data.body) {
        let addInput = document.createElement('input')

        addInput.name = key
        addInput.value = resp.data.body[key]

        form.appendChild(addInput)
      }

      document.body.appendChild(form)
      form.submit()
    } else {
      toast.error(`Error Launching - ${resp.data.error}`)
    }
  }

  return (
    <Fragment>
      <p>Enter the URL used at original launch:</p>
      <input
        type="text"
        className="form-control mb-3"
        defaultValue={
          props.log.params.launch_url !== 'missing'
            ? props.log.params.launch_url
            : ''
        }
        onChange={e => setLaunchUrl(e.target.value)}
      />
      <button
        onClick={() => launch()}
        className="btn btn-myed btn-success btn-success-myed"
      >
        Launch
      </button>
    </Fragment>
  )
}

export default LaunchRecreationInput

LaunchRecreationInput.propTypes = {
  log: PropTypes.object,
}
